export default function HorizontalLine() {
    return (
        <div className="flex items-center justify-center mb-10 mt-7">
            <svg width="1397" height="17" viewBox="0 0 1397 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 9H1396" stroke="#222222"/>
            <path d="M1396 0V17" stroke="black"/>
            <path d="M1 0V17" stroke="black"/>
            </svg>
        </div>
    );
  }






